<template>
    <z-basePage :title="'职级充值'">
        <div class="search-top">
            <!-- <span>BU名称</span>
            <el-select class="top-choose" v-model="buId" @change="searchClick()">
                <z-limitOption v-for="item in bu_list" :key="item.id" :value="item.id" :label="item.bu_name">
                </z-limitOption>
            </el-select> -->
            <!-- <span>时间</span>
            <el-date-picker class="top-choose" v-model="search.start_date" type="date" placeholder="选择日期" :picker-options="picker_special">
			</el-date-picker>
            <small>~</small>
            <el-date-picker class="top-choose" v-model="search.end_date" type="date" placeholder="选择日期" :picker-options="picker_special">
			</el-date-picker> -->

            <!-- <div class="back-btn blue" @click="searchClick()">查询</div> -->
            <div class="back-btn orange" @click="pop.show = true">批量充值</div>
        </div>

        <div class="back-list page">
            <div class="list-head">
                <div>BU名称</div>
                <div>可分配职级</div>
                <div>操作</div>
            </div>
            <z-scrollDiv class="main">
                <div class="list-item" v-for="item in data" :key="item.id">
                    <div>{{ item.bu_name }}</div>
                    <div>{{ item.balance }}</div>
                    <div class="orange-text" @click="link(item.bu_id)">充值</div>
                </div>
                <z-noData :list="data"></z-noData>
            </z-scrollDiv>
        </div>

        <z-windowPop :show="pop.show" :title="pop.title" 
        :noBtns='true' :width="'900px'" @cancel="closePop" v-form="'back-rank-all'">
            <div class="back-list pop-list">
                <div class="list-head">
                    <div>BU名称</div>
                    <div>可分配职级</div>
                    <div>充值数量</div>
                </div>
                <z-scrollDiv class="main">
                    <div class="list-item"  v-for="item in data" :key="item.id">
                        <div>{{ item.bu_name }}</div>
                        <div>{{ item.balance }}</div>
                        <el-input class="recharge-value" v-model="pop.bu_list[item.bu_id]" v-tar="pop.bu_list[item.bu_id]" rule="noTip_number"></el-input>
                    </div>
                    <!-- <z-noData :list="data"></z-noData> -->
                </z-scrollDiv>
            </div>
            <div class="pop-remark">
                <div class="title">备注</div>
                <div class="area">
                    <el-input 
                        type="textarea" 
                        :rows="4"
                        resize="none"
                        placeholder="请输入备注信息"
                        v-tar="pop.remark"
                        rule="noVal"
                        v-model="pop.remark">
                    </el-input>
                </div>
                <div class="btns">
                    <div class="back-btn orange" @click="rechargeAll">完成充值</div>
                    <div class="back-btn" @click="closePop">取消</div>
                </div>
            </div>
        </z-windowPop>
    </z-basePage>
</template>

<script>
    import { mapState } from "vuex"

    export default {
        data(){
            return {
                search:{
                    start_date:"",
                    end_date:"",
                },
                // buId:"",   //bu id
                data:[],   //数据
                pop:{
                    show:false,
                    title:"职级批量充值",
                    bu_list:{},
                    remark:"管理员批量调整职级",
                }
            }
        },
        computed:{
            ...mapState(['picker_special']),
            // dataList(){
            //     return this.data.list;
            // }
        },

        created(){
            // this.$func.getBuList(true,list=>{
            //     this.buId = list[0] && list[0].id;
            // });
            this.getData();
        },

        methods:{
            link(id){
                let str = this.$crypto.encrypt(id);
                this.$router.push({
                    name:"back-finance-rank-add",
                    params:{
                        id:str,
                    },
                });
            },
            getData(obj={}){
                // obj.bu_id = this.buId;

                // let url = `api/admin/bu/pmtdetail`;
                let url = `api/admin/all_pmt_level_summary/list`;
                this.$http.get(url)
                .then(res=>{
                    if(res.status == 200){
                        this.data = res.res_data;
                    }
                });
            },
            // searchClick(page){  //查询
            //     let obj = {
            //         page:page,
            //         start_date:this.search.start_date,
            //         end_date:this.search.end_date,
            //     }
            //     this.getData(obj);
            // },

            // ***批量充值
            closePop(){  //关闭弹窗
                this.$form.clear("back-rank-all");
                this.pop.show = false;
                this.pop.bu_list = {};
                this.pop.remark = "管理员批量调整职级";
            },

            rechargeAll(){  //批量充值
                let res = this.$form.check("back-rank-all");
                if(!res){
                    return;
                }

                this.$func.loading(true);

                let obj = {};
                for(let key in this.pop.bu_list){
                    obj[key] = parseInt(this.pop.bu_list[key]);
                }

                let url = `api/admin/all_pmt/recharge`;
                this.$http.post(url,{
                    bu_list:obj,
                    remark:this.pop.remark,
                })
                .then(res=>{
                    if(res.status == 200){
                        this.closePop();
                        this.getData();
                        this.successTip('批量充值成功');
                    }
                    this.$func.loading(false);
                })
                .catch(err=>{
                    this.errorTip('出错了');
                    this.$func.loading(false);
                })

            },

        }
    }
</script>

<style lang="less" scoped>

    .list-head,.list-item{
        >div:nth-of-type(1){
            width: 30%;
        }
        >div:nth-of-type(2){
            width: 30%;
        }
        >div:nth-of-type(3){
            width: 10%;
            cursor: pointer;
        }
        // .add{
        //     color:#34b96c;
        //     // color:#43a2ff;
        // }
        // .reduce{
        //     color:#ff8383;
        // }
    }
</style>


// WEBPACK FOOTER //
// page-rank-recharge.vue?588e0b4e